import { TTableStructureColors, TTableStructureFilter } from 'ui/EasTable/types';

/**
 * `MassPostSaleJobListItemResponse.status` and `MassPostSaleJobOrderResponse.status` are plain
 * strings in the API contract — no enum is published in swagger. The values below mirror the
 * per-status order counters returned with a job (processed / partial / rejected / warning) plus
 * the lifecycle states a job goes through. Any status that is not listed here still renders,
 * it simply falls back to the raw value coming from the API.
 */
export enum EMassPostSaleJobStatus {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
}

export const MASS_POST_SALE_JOB_STATUS_FILTER: TTableStructureFilter = [
	[EMassPostSaleJobStatus.PENDING, 'Pending'],
	[EMassPostSaleJobStatus.COMPLETED, 'Completed'],
];

export const MASS_POST_SALE_JOB_STATUS_COLORS: TTableStructureColors = [
	[EMassPostSaleJobStatus.PENDING, 'warning.light'],
	[EMassPostSaleJobStatus.COMPLETED, 'success.light'],
];

export enum EMassPostSaleJobOrderStatus {
	SUCCESSFUL = 'successful',
	REJECTED = 'rejected',
	PARTIAL = 'partial',
}

export const MASS_POST_SALE_JOB_ORDER_STATUS_FILTER: TTableStructureFilter = [
	[EMassPostSaleJobOrderStatus.SUCCESSFUL, 'Successful'],
	[EMassPostSaleJobOrderStatus.REJECTED, 'Rejected'],
	[EMassPostSaleJobOrderStatus.PARTIAL, 'Partial'],
];

export const MASS_POST_SALE_JOB_ORDER_STATUS_COLORS: TTableStructureColors = [
	[EMassPostSaleJobOrderStatus.SUCCESSFUL, 'success.light'],
	[EMassPostSaleJobOrderStatus.REJECTED, 'error.light'],
	[EMassPostSaleJobOrderStatus.PARTIAL, 'warning.light'],
];

export const MASS_POST_SALE_JOBS_ACTIONS = {
	VIEW_ORDERS: 'View orders',
};

export enum EMassPostSaleJobOrderProcessingType {
	WITH_LC = 'with_lc',
	WITHOUT_LC = 'without_lc',
}
export const MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_FILTER: TTableStructureFilter = [
	[EMassPostSaleJobOrderProcessingType.WITH_LC, 'With LC'],
	[EMassPostSaleJobOrderProcessingType.WITHOUT_LC, 'Without LC'],
];

// export const MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_COLORS: TTableStructureColors = [
// 	[EMassPostSaleJobOrderProcessingType.WITH_LC, 'success.light'],
// 	[EMassPostSaleJobOrderProcessingType.WITHOUT_LC, 'warning.light'],
// ];
